import { achievementViewsFromGrants, globalAchievementValues } from "@dailywars/core/achievements";
import {
  getAchievementEarnCounts,
  getAllAchievementGrants,
  getPlayerByDisplayName,
} from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";
import * as z from "zod";

import { setRouteAction } from "#/lib/requestLogger.server";

export const getPlayerAchievements = createServerFn({ method: "GET" })
  .validator(z.object({ name: z.string().min(1) }))
  .handler(async ({ data }) => {
    setRouteAction("get_player_achievements");
    const player = await getPlayerByDisplayName(data.name);
    if (!player) return null;

    const [grants, achievementEarnCounts] = await Promise.all([
      getAllAchievementGrants(player.playerId),
      getAchievementEarnCounts(),
    ]);
    return {
      displayName: player.displayName,
      achievements: achievementViewsFromGrants(grants),
      achievementValues: globalAchievementValues(player),
      achievementEarnCounts,
    };
  });
